<template>
  <component
    v-if="routing"
    :is="'Privacy' + routing.replaceAll(' ', '')"
    @done="$emit('done', { value: 'Akzeptiert', id: question.id })"
  ></component>
</template>

<script>
import PrivacyMedgate from "@arag/components/Privacy";
import PrivacyARAGCaseManagement from "@arag/components/PrivacyArag";
import PrivacyARAGCaseManagementZahn from "@arag/components/PrivacyAragZahn";
import PrivacyBetterDoc from "@arag/components/PrivacyBetterDoc";
import PrivacyZTK from "@arag/components/PrivacyZTK";

export default {
  emits: ["done"],
  components: {
    PrivacyMedgate,
    PrivacyARAGCaseManagement,
    PrivacyARAGCaseManagementZahn,
    PrivacyBetterDoc,
    PrivacyZTK,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    routing: {
      required: true,
      type: String,
    },
  },
};
</script>

<style></style>
